// extracted by mini-css-extract-plugin
export default {"message":"tdjeW","countdown":"_1D7i5","countdown-value":"_7D99f","countdownValue":"_7D99f","countdown-ended":"_2mDbD","countdownEnded":"_2mDbD"};